export default {
  "checkbox-container": "_checkbox-container_1cf7wg",
  "checkbox": "_checkbox_1cf7wg",
  "check-01": "_check-01_1cf7wg",
  "check-02": "_check-02_1cf7wg",
  "firework": "_firework_1cf7wg"
};
